// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3tB1G","colBig":"styles_colBig__99IgD","colSmall":"styles_colSmall__22qhn","shopifyNameWrapper":"styles_shopifyNameWrapper__2fkMC"};